// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from './config'
import echarts from 'echarts'
import axios from 'axios'
import moment from 'moment';
import Vuex from 'vuex'
import store from './vuex/store'
import './assets/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import './assets/css/reset.css'
import './assets/css/public.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Message } from 'element-ui'

Vue.prototype.$http = axios
Vue.prototype.config = config
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Vuex)

//导航守卫
router.beforeEach((to, from, next) => {

  if (to.path !== '/login' && to.path !== '/register'  && !isAuth()) {

    Message({
      message: "请先登录",
      type: 'error',
      duration: 3 * 1000,
    })
    console.log(to.path);
    next('/login?redirect=' + to.path)
  } else {

    next()
  }
}

)

function isAuth() {

  var token = localStorage.token;
  return token !== undefined && token !== null
}

// http请求拦截器
axios.interceptors.request.use(config => {

  if (localStorage.token) {
    config.headers["Authorization"] = "Bearer " + localStorage.token
  }
  return config;
})
// http响应拦截器
axios.interceptors.response.use(
  response => {

    const res = response.data
    if (res.code !== "10000") {

      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000,
        //offset: 200
      })

      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res.data
    }
  },
  error => {
    console.log(error) // for debug
    Message({
      message: '网络异常，请稍后重试',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js